import { render, staticRenderFns } from "./LocationSelection.vue?vue&type=template&id=2182372c&"
import script from "./LocationSelection.vue?vue&type=script&lang=js&"
export * from "./LocationSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports